import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import './style.css'
import 'flag-icons/css/flag-icons.min.css'
import { registerGlobalImageFallback } from './plugins/imageFallback'
import { useCmsStore } from './store/cms'

const app = createApp(App)

// Initialize Sentry
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0, // 10% in production, 100% in development
  replaysSessionSampleRate: 0.1, // 10% of sessions will be recorded
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with an error will be recorded
})

app.use(createPinia())
app.use(router)
registerGlobalImageFallback()

// Pre-fetch CMS content so it's ready before components mount.
// Hardcoded fallbacks are used instantly; CMS data replaces them transparently.
useCmsStore().fetchAll()

app.mount('#app')
